import { Grid } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";

export const StyledGrid = styled(Grid)`
  height: 250px;

  & .videoBox {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    margin: 8px;
    transition: 500ms;
    border: ${(props) =>
      props.$isActive
        ? `8px solid ${theme.palette.primary.main}`
        : "1px solid transparent"};
  }
`;
